// Ejemplo Environment
const API_BASE_URL = 'https://bctestnet2faucet.xpxsirius.io'
const API_URL = 'https://bctestnet2faucet.xpxsirius.io/api'

export default {
  API_BASE_URL,
  API_URL
}
